import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import "./style.css";
import { Backdrop, CircularProgress, Grid2, Typography } from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import Button from "@mui/material/Button";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DevicesOtherIcon from "@mui/icons-material/DevicesOther";
import Patrocinadores from "../patrocinio/Patrocinadores";
import Conferencistas from "../conferencistas/Conferencistas";
import { Modal } from "@mui/material";
const admin_service = require("../../helpers/admin_service");
const helpers = require("../../helpers/helpers");

const Inicio = () => {
  const [contador] = useState(0);
  const [evento, setEvento] = useState({});
  const [patrocinadores, setPatrocinadores] = useState({});
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90vw",
    height: "90vh",
    bgcolor: "transparent",

    p: 4,
  };
  useEffect(() => {
    admin_service
      .getData("/evento/view-by-hash/" + process.env.REACT_APP_EVT)
      .then((response_evt) => {
        admin_service
          .getData("/patrocinador/view-by-evento/" + process.env.REACT_APP_EVT)
          .then((response_patrocinador) => {
            setEvento(response_evt.data.response_database.result[0]);
            setPatrocinadores(response_patrocinador.data.response.result);
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  }, [contador]);
  return (
    <Box paddingTop={10}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Stack spacing={4} alignItems="center">
        <Typography variant="h4" style={{ textAlign: "center" }}>
          <EventIcon /> &nbsp;22 de enero 2026
        </Typography>
        <Typography variant="h5" style={{ textAlign: "center" }}>
          <DevicesOtherIcon /> &nbsp;100% Virtual
        </Typography>
        <Box style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <Button
            style={{
              backgroundColor: "#e0721d",
              color: "white",
              border: "1px solid transparent",
              fontWeight: "bold",
              fontSize: "1.2em",
              padding: "10px 30px",
              marginBottom: "20px",
            }}
            variant="outlined"
            startIcon={<DriveFileRenameOutlineIcon />}
            onClick={() => {
              window.open(
                `${process.env.REACT_APP_URL_INSCRIPCION}${process.env.REACT_APP_EVT}`,
                "_blank"
              );
            }}
          >
            Inscríbete en Línea
          </Button>
        </Box>

        <Stack alignItems="center" justifyContent="center" spacing={5}>
          <Grid2
            container
            alignItems="center"
            justifyContent="center"
            style={{ textAlign: "justify" }}
          >
            {evento.video_promo && (
              <video
                autoPlay
                muted
                playsInline
                loop
                style={{
                  width: "75%",
                }}
              >
                <source src={evento.video_promo} type="video/mp4" />
              </video>
            )}
            <Grid2 size={{ xs: 12, md: 6, lg: 10 }}>
              <Typography variant="h4">
                ¿Qué es el Foro Económico Regional?
              </Typography>
              <Typography variant="p">
                La Asociación Bancaria de Guatemala -ABG-, comprometida con el
                desarrollo económico de la región, organiza el XV Foro
                Económico Regional (FECORE), un evento que se ha consolidado
                como un espacio único para analizar las oportunidades y desafíos
                que enfrenta Centroamérica y el Caribe en su camino hacia un
                crecimiento sostenible.Este foro busca reunir a destacados
                líderes empresariales, expertos económicos, académicos y
                profesionales interesados en profundizar en temas clave que
                afectan el desarrollo económico regional, permitiendo el
                intercambio de ideas, experiencias y soluciones innovadoras para
                afrontar los retos actuales.
                <br />
                <br /> El temario preliminar del evento incluye temas de alta
                relevancia, como las perspectivas de crecimiento económico para
                Centroamérica y el Caribe, áreas clave de inversión que impulsan
                el desarrollo, el turismo como motor de crecimiento, y el
                impacto que tiene la calificación de riesgo país en la economía
                de la región. Además, se analizarán los retos de la integración
                económica y cómo esta puede convertirse en una herramienta
                esencial para potenciar el crecimiento colectivo. También se
                llevará a cabo un conversatorio centrado en los efectos de las
                elecciones presidenciales en los Estados Unidos, abordando
                cuestiones como las remesas, la migración y los cambios
                geopolíticos que influyen directamente en la estabilidad
                económica de la región. Por último, se presentará un foro
                dedicado a explorar los desafíos y estrategias para maximizar el
                potencial de crecimiento económico regional.
              </Typography>
            </Grid2>
          </Grid2>
        </Stack>
        {//<Conferencistas />
        }
        <Grid2 container alignItems="center" justifyContent="center">
          <Grid2 xs={12} md={6} lg={6}>
            <Stack spacing={2} style={{ padding: "6%" }}>
              <Typography variant="h5" style={{ textAlign: "center" }}>
                Dirigido a:
              </Typography>
              <Typography
                variant="p"
                style={{ textAlign: "left", fontSize: "0.9em" }}
              >
                <ul className="columns">
                  <li>
                    Presidentes y Directores de Bancos y Entidades Financieras
                  </li>
                  <li>Gerentes Generales de Instituciones Bancarias</li>
                  <li>Gerentes de Banca Corporativa y Comercial</li>
                  <li>Analistas de Riesgo Financiero</li>
                  <li>
                    Responsables de Estrategia e Innovación en el Sector
                    Financiero
                  </li>
                  <li>Especialistas en Inversiones y Desarrollo Económico</li>
                  <li>Consultores en Integración Financiera Regional</li>
                  <li>Profesionales en Transformación Digital Bancaria</li>
                  <li>
                    Ejecutivos de Marketing Financiero y Experiencia del Cliente
                  </li>
                  <li>Académicos y Expertos en Economía Financiera</li>
                </ul>
              </Typography>
            </Stack>
          </Grid2>
        </Grid2>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <img
              src={evento.planos}
              alt={evento.hash}
              style={{ width: "100%", objectFit: "contain", height: "100%" }}
              loading="lazy"
            />
          </Box>
        </Modal>
      </Stack>
    </Box>
  );
};

export default Inicio;
